/* eslint-disable max-lines-per-function */
'use strict';

export default class QuantityAdjust {
	constructor ({
		increaseButton = null,
		decreaseButton = null,
		min = 0
	} = {}) {
		this.$increaseButton = increaseButton;
		this.$decreaseButton = decreaseButton;
		this.min = min;

		this.onClickCallback = null;

		this.onInit();
	}

	onInit () {
		const self = this;

		// Increase
		this.$increaseButton.on('click', function (event) {
			const $qty = $(this).prev('input');
			const currentVal = parseInt($qty.val(), 10);

			if (!isNaN(currentVal)) {
				$qty.val(currentVal + 1).change();
				$qty[0]?.dispatchEvent?.(new Event('change'));
			}

			if (self.onClickCallback !== null) {
				self.onClickCallback(event);
			}
		});

		// Decrease
		this.$decreaseButton.on('click', function (event) {
			const $qty = $(this).next('input');
			const currentVal = parseInt($qty.val(), 10);

			if (!isNaN(currentVal) && currentVal > self.min) {
				$qty.val(currentVal - 1).change();
				$qty[0]?.dispatchEvent?.(new Event('change'));
			}

			if (self.onClickCallback !== null) {
				self.onClickCallback(event);
			}
		});
	}

	onClick (callback) {
		this.onClickCallback = callback;
	}
};
